import { UserActivatedRecord } from '../cycles/models/CycleRecords';

export function isEmployedAtEndDate(user: UserActivatedRecord, endDate: Date): boolean {
	if (user.excludeAnalytics) return false;

	const activatedAt = user.activatedAt ?? null;
	const deactivatedAt = user.deactivatedAt ?? null;
	const archivedAt = user.archivedAt ?? null;

	if (activatedAt && activatedAt >= endDate) return false;
	if (deactivatedAt && deactivatedAt <= endDate) return false;
	if (archivedAt && archivedAt <= endDate) return false;

	return true;
}

export function employedUserIDsAtEndDate<T extends UserActivatedRecord>(
	users: T[],
	endDate: Date,
	getID: (user: T) => string,
): Set<string> {
	return new Set(
		users.filter((user) => isEmployedAtEndDate(user, endDate)).map((user) => getID(user)),
	);
}
